// extracted by mini-css-extract-plugin
module.exports = {"root":"IconStar_root__xOmbp"};